<script setup lang="ts">
    import { ref, onMounted } from 'vue'
    import { useI18n } from 'vue-i18n'
    import axios from 'axios'
    import {
      Select,
      SelectTrigger,
      SelectValue,
      SelectContent,
      SelectGroup,
      SelectLabel,
      SelectItem,
    } from "@/components/ui/select"
    
    const { locale } = useI18n()
    
    const languages = [
      { value: 'de', label: 'Deutsch' },
      { value: 'en', label: 'English' },
      { value: 'zh-TW', label: '中文' }
    ]
    
    const currentLocale = ref(locale.value || 'de')
    
    // Load saved language preference from localStorage
    onMounted(() => {
      const savedLocale = localStorage.getItem('app_locale')
      if (savedLocale && (savedLocale === 'de' || savedLocale === 'en' || savedLocale === 'zh-TW')) {
        currentLocale.value = savedLocale
        locale.value = savedLocale
      } else {
        // Default to German
        currentLocale.value = 'de'
        locale.value = 'de'
        localStorage.setItem('app_locale', 'de')
      }
      // Set initial locale header
      axios.defaults.headers.common['X-Locale'] = locale.value
    })
    
    function handleLanguageChange(newLocale: string) {
      currentLocale.value = newLocale
      locale.value = newLocale
      localStorage.setItem('app_locale', newLocale)
      // Set cookie for initial page loads
      document.cookie = `app_locale=${newLocale}; path=/; max-age=${365 * 24 * 60 * 60}`
      // Update axios header immediately
      axios.defaults.headers.common['X-Locale'] = newLocale
      // Reload page to refresh specs data with new locale
      window.location.reload()
    }
    </script>
    
    <template>
      <div class="hoeppner-bg-white h-10">
        <Select :model-value="currentLocale" @update:model-value="handleLanguageChange">
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>Sprache / Language / 语言</SelectLabel>
              <SelectItem
                v-for="lang in languages"
                :key="lang.value"
                :value="lang.value"
              >
                {{ lang.label }}
              </SelectItem>
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </template>
    